import React from 'react';

import { Form, Formik, FormikProps } from 'formik';
import * as Yup from 'yup';

import BounceLoader from '@common/react/components/UI/Loaders/BounceLoader';

import CustomModalMessage from '@app/components/UI/CustomModalMessage/CustomModalMessage';
import styles from '@app/components/UI/Login/RecoverFormLayout/RecoverFormLayout.module.scss';

interface RecoverFormLayoutProps {
	title: string;
	initialValues: any;
	validationSchema: Yup.object;
	successfulMessage: string;
	onBack: () => void;
	onSubmit: (values: any) => Promise<any>;
	render: (formikBag: FormikProps<any>) => React.ReactNode;
	description?: string;
}

const RecoverFormLayout: React.FC<RecoverFormLayoutProps> = ({
	title,
	initialValues,
	validationSchema,
	successfulMessage,
	onBack,
	onSubmit,
	render,
	description = '',
}) => {
	const [sending, setSending] = React.useState(false);
	const [message, setMessage] = React.useState('');
	const [modalMessage, setModalMessage] = React.useState(false);

	return (
		<>
			<Formik
				onSubmit={(values) => {
					setSending(true);
					setModalMessage(false);
					setMessage('');

					onSubmit(values)
						.then(() => setMessage(successfulMessage))
						.catch((err) => setMessage(err))
						.finally(() => {
							setSending(false);
							setModalMessage(true);
						});
				}}
				initialValues={initialValues}
				validationSchema={validationSchema}
			>
				{(formikBag) => (
					!sending ? (
						<Form autoComplete="off">
							<h1 className="h2">
								{title}
							</h1>
							{description && (
								<p className="h4 text-center">
									{description}
								</p>
							)}

							{render(formikBag)}

							<div className={styles.btnsWrap}>
								<button
									type="button"
									className="btn btn-light-purple"
									onClick={onBack}
								>
									Back
								</button>
								<button
									type="submit"
									className="btn btn-primary"
								>
									Continue
								</button>
							</div>
						</Form>
					) : (
						<BounceLoader />
					)
				)}
			</Formik>

			{modalMessage && (
				<CustomModalMessage
					modalVisible={modalMessage}
					setModalVisible={setModalMessage}
					title={message}
				/>
			)}
		</>
	);
};

export default RecoverFormLayout;
